import type { BankAccountResource } from "../../bank-account";
import type { BankTransactionResource } from "../../bank-transaction";

export enum BankSepaEnum {
  Credit = "credit",
  DebitCore = "debit_core",
  DebitB2b = "debit_b2b",
}

export interface BankSepaResource {
  id: string;
  bankAccount?: BankAccountResource;
  bank_account_id: string;
  amount: string;
  bank_transaction_id: string | null;
  bankTransaction?: BankTransactionResource;
  quantity: number;
  type: BankSepaEnum;
}
